"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;



































































































































var _user = require("@/utils/user");
var _formatter = require("@/utils/formatter"); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = { data: function data() {return { tableData: [], // 列表数据
      imageList: [], newadd: false, isDetailShow: false, patient: {}, ward: '', searchData: { ward: '', bedspace: '', page: 1, // 页码条数
        rows: 10 }, pageData: { page: 1, rows: 10, total: 0, pages: 1 }, addData: { id: '', ward: '', bedspace: '' }, rules: { ward: [{ required: true, message: '请输入病房号', trigger: 'blur' }], bedspace: [{ required: true, message: '请输入床位号', trigger: 'blur' }] }, // 表格列
      tableColumns: [{ prop: 'ward', label: '病房号', isShow: true }, { prop: 'bedspace', label: '床位号', isShow: true }] };}, mounted: function mounted() {var self = this;self.init();}, methods: { init: function init() {var self = this;self.getData('/api/temi/medical/bed', self.searchData, function (res) {self.tableData = res.list;self.pageData.page = res.pageNum;self.pageData.total = res.total;});}, checkPermission: _user.checkPermission, simpleFormatter: _formatter.simpleFormatter, resetFun: function resetFun() {// 重置
      this.searchData.ward = '';this.searchData.bedspace = '';this.init();}, searchFun: function searchFun() {// 搜索事件
      this.searchData.page = 1;this.init();}, handleSizeChange: function handleSizeChange(val) {// 分页条数
      this.searchData.rows = val;this.searchData.page = 1;this.init();}, handleCurrentChange: function handleCurrentChange(val) {// 分页页码
      this.searchData.page = val;this.init();}, addFun: function addFun() {// 新增
      this.ward = '新增';this.newadd = true;}, closeDiglog: function closeDiglog() {// 关闭弹出层
      this.$refs['addForm'].resetFields();this.cleanData();this.newadd = false;this.newadd2 = false;}, updateMenu: function updateMenu(item) {// 修改操作
      this.ward = '修改';var self = this;self.newadd = true;self.addData = { id: item.id, ward: item.ward, bedspace: item.bedspace };}, handleLookPatient: function handleLookPatient(item) {console.log('i', item);this.isDetailShow = true;this.handleGetPatient(item);}, handleGetPatient: function handleGetPatient(bedId) {var self = this;self.getData('/api/temi/medical/patient/bed/' + bedId, {}, function (res) {self.patient = res;console.log('patient', self.patient);});}, onSubmit: function onSubmit() {// 新增提交操作
      var self = this;self.$refs.addForm.validate(function (valid) {if (valid) {self.postData('/api/temi/medical/bed', self.addData, function (res) {self.$message({ message: '添加成功!', type: 'success' });self.onCencal();self.searchData.page = 1;self.init();});} else {return false;}});}, delMenu: function delMenu(delId) {// 删除操作
      var self = this;self.$confirm('确定删除该记录吗？', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning',
        center: true }).
      then(function () {
        self.delData('/api/temi/medical/bed?id=' + delId, {}, function (res) {
          self.$message({
            message: '删除成功!',
            type: 'success' });

          self.searchData.page = 1;
          self.init();
        });
      }).catch(function () {});
    },
    onCencal: function onCencal() {// 关闭弹出框
      this.$refs.addForm.resetFields();
      this.cleanData();
      this.newadd = false;
    },
    handleCloseDetail: function handleCloseDetail() {
      this.patient = {};
      this.isDetailShow = false;
    },
    cleanData: function cleanData() {// 清理输入的数据
      this.addData = {
        id: '',
        ward: '',
        bedspace: '' };

    } } };exports.default = _default;